import { CategoryThemes } from '~/types/category';

interface ICardCustomization {
    bundle: IBundle;
    theme?: CategoryThemes;
}

const Customization = ({ bundle, theme }: ICardCustomization) => {
    switch (theme) {
        default:
            return <></>;
    }
};

export default Customization;
